import { __awaiter, __generator } from "tslib";
import { getAdminConstructionApiUrl } from "@adsk/acs-sc-web-platform-api";
import fetcherWithRegionHeader from "../../utils/fetcherWithRegionHeader";
export var fetchProjectUser = function (props) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, fetcherWithRegionHeader("".concat(getAdminConstructionApiUrl(), "/v1/projects/").concat(props.projectId, "/users/").concat(props.userId))];
    });
}); };
